import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PREPARE_DISCLOSURES_WIZARD_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/prepareDisclosuresWizard`,
  {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
  },
);

export const openPrepareDisclosuresWizardAction = () => ({
  type: PREPARE_DISCLOSURES_WIZARD_ACTION_TYPE.OPEN,
});

export const closePrepareDisclosuresWizardAction = () => ({
  type: PREPARE_DISCLOSURES_WIZARD_ACTION_TYPE.CLOSE,
});
